import React from 'react';
import { FadeIn } from './FadeIn';
import { Settings, Zap, Calendar } from 'lucide-react';
export function ProductPresentation() {
  const features = [{
    icon: <Settings className="w-8 h-8 text-dark" data-id="element-170" />,
    title: 'Power Engineering',
    description: 'How your "hydraulic pump" works and how to turn it on at will, mastering your physiology.'
  }, {
    icon: <Zap className="w-8 h-8 text-dark" data-id="element-171" />,
    title: 'The Regeneration Protocol',
    description: 'Specific nutrition and supplements to clean your arteries and trigger your Nitric Oxide.'
  }, {
    icon: <Calendar className="w-8 h-8 text-dark" data-id="element-172" />,
    title: 'The 30-Day Plan',
    description: 'What to do step-by-step for a total transformation. No guesswork, just results. You will achieve and improve your erections.'
  }];
  return <section className="py-24 px-6 bg-dark-card relative overflow-hidden" data-id="element-173">
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-gold/30 to-transparent" data-id="element-174"></div>
      <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-gold/30 to-transparent" data-id="element-175"></div>

      <div className="max-w-5xl mx-auto" data-id="element-176">
        <FadeIn data-id="element-177">
          <div className="text-center mb-20" data-id="element-178">
            <span className="text-gold tracking-[0.2em] text-sm uppercase mb-4 block font-semibold" data-id="element-179">
              Introducing
            </span>
            <h2 className="text-5xl md:text-7xl font-serif font-bold text-gold mb-6 drop-shadow-lg" data-id="element-180">
              The Master Code
            </h2>
            <p className="text-xl md:text-2xl text-gray-300 font-serif max-w-3xl mx-auto" data-id="element-181">
              Teaches you how your sexual system works from the inside out and
              how to optimize it. Using scientific research, biohacking, and
              advanced nutrition.
            </p>
          </div>
        </FadeIn>

        <div className="space-y-8" data-id="element-182">
          {features.map((feature, index) => <FadeIn key={index} delay={0.1 * index} data-id="element-183">
              <div className="flex flex-col md:flex-row items-start md:items-center gap-6 bg-dark border border-gold/20 p-8 rounded-sm hover:bg-dark-lighter transition-colors duration-300" data-id="element-184">
                <div className="flex-shrink-0 bg-gradient-to-br from-gold to-gold-dark w-16 h-16 rounded flex items-center justify-center shadow-[0_0_15px_rgba(212,175,55,0.3)]" data-id="element-185">
                  {feature.icon}
                </div>
                <div data-id="element-186">
                  <h3 className="text-2xl font-serif font-bold text-white mb-2" data-id="element-187">
                    {feature.title}
                  </h3>
                  <p className="text-gray-400 text-lg leading-relaxed" data-id="element-188">
                    {feature.description}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}